// extracted by mini-css-extract-plugin
module.exports = {"button":"GlobalSearch_button__1GsZs","content":"GlobalSearch_content__1Fj1-"};